import { useConfig } from '@/config/config';

export const getFullImageUrl = (imagePath: string | null | undefined): string => {
  if (!imagePath) return '';

  const { imagesServerHost } = useConfig();
  return `${imagesServerHost}${imagePath}`;
};
